import PlanIformation from "../PlanIformation/PlanIformation"
import Authorization from "../Authorization/Authorization"
import Eligibility from "../Eligibility/Eligibility"
import Referals from "../Referals/Referals"
import { useSelector } from "react-redux"
import { FindFirstChild } from "../../../../../utils/FindMenuOption"
const InsurranceMenu = () => {
    return [
        {
            name: '',
            key: 213,
            icon: "",
            right: true,
            subCategoryItems: [
                {
                    name: 'Plan Info',
                    key: 2131,
                    icon: <img src={process.env.PUBLIC_URL + "/assets/images/arrow-right-circle.svg"}  alt="" />,
                    component: <PlanIformation />,
                    right: FindFirstChild('Patient','Insurance/Plan info')?.ISView,
                },
                {
                    name: 'Authorization',
                    key: 2132,
                    icon: "",
                    component: <Authorization />,
                    right: true,
                    // right: FindFirstChild('Patient','Authorization')?.ISView,
                },
                {
                    name: 'Eligibility',
                    key: 2133,
                    icon: "",
                    component: <Eligibility />,
                    // right: true,
                    right: FindFirstChild('Patient','Eligibility')?.ISView,
                },
                // {
                //     name: 'Referals',
                //     key: 2134,
                //     icon: "",
                //     component: <Referals/>,
                //     // right:  FindFirstChild('Patient','Referals')?.ISView,
                //     right: true,
                // }
            ]
        },
    ]
}


export default InsurranceMenu